export const gtmLoadInterval = (callback) => {
  const interval = setInterval(() => {
    window.dataLayer = window?.dataLayer || [];
    const isGtmLoaded = window?.dataLayer?.some((x) => x?.event === "gtm.load");
    if (isGtmLoaded) {
      callback();
      clearInterval(interval);
    }
  }, 1000);

  return () => clearInterval(interval);
};
